/* Videos that should autoplay (muted, looping) start only when they scroll into view and pause when they
   leave. They are rendered with preload="none" and no autoplay attribute, so nothing downloads at page load
   (an autoplay attribute makes the browser fetch the whole file immediately, even far below the fold).

   Posters: video[data-kr-poster] gets its poster when its section comes within one screen of the viewport
   (or when the video itself becomes visible, e.g. a reel player that opens), so a carousel of 29 reels
   does not download 29 poster images at page load. Same image, same quality, just fetched later. */
(function () {
  function setPoster(v) {
    var p = v.getAttribute('data-kr-poster');
    if (p) { v.setAttribute('poster', p); v.removeAttribute('data-kr-poster'); }
  }
  function posters() {
    var vids = document.querySelectorAll('video[data-kr-poster]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(setPoster); return; }
    var groups = new Map();
    vids.forEach(function (v) {
      var g = v.closest('.shopify-section') || v.parentElement;
      if (!groups.has(g)) groups.set(g, []);
      groups.get(g).push(v);
    });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        if (e.target.tagName === 'VIDEO') setPoster(e.target);
        else (groups.get(e.target) || []).forEach(setPoster);
      });
    }, { rootMargin: '100% 0px' });
    groups.forEach(function (_, g) { io.observe(g); });
    vids.forEach(function (v) { io.observe(v); });
  }
  function autoplay() {
    var vids = document.querySelectorAll('video[data-kr-autoplay]');
    if (!vids.length) return;
    function play(v) { setPoster(v); v.muted = true; v.setAttribute('playsinline', ''); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) play(e.target); else e.target.pause(); });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }
  function init() { posters(); autoplay(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
